import { ResponseBaseModel } from "../models";
import AlYusrAxiosApiInstance, {
  AxiosSearchParams,
} from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import {
  EinvoiceTransactionListModel,
  EinvoiceTransactionSearchParamsModel,
} from "../models/einvoiceTransaction/einvoiceTransactionModel";

export const searchEnvoiceTransaction = async (
  request?: EinvoiceTransactionSearchParamsModel
): Promise<ResponseBaseModel<EinvoiceTransactionListModel[]>> => {
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.einvoiceTransactionController.searchEinvoiceTransactions,
    { params: AxiosSearchParams(request ?? {}, "searchParamter") }
  );
};

export const reUploadEinvoiceTransaction = async (
  request: Array<{
    TransactionId: number;
    BranchId: number;
    UserId: number;
  }>
): Promise<ResponseBaseModel<EinvoiceTransactionListModel[]>> => {
  return await AlYusrAxiosApiInstance.post(
    AlYuserApiUrls.einvoiceTransactionController.reUploadEinvoiceTransactions,
    request
  );
};
